import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private httpclient: HttpClient) { }

  GetAddMemberInitialModel(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/GetAddMemberInitialModel',member);
  }
  AddCustomer(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/AddCustomer',member);
  }
  GetItemList(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/GetItemList',member);
  }
  // AddTransactionItem(member:any) {
  //   return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/AddTransactionItem',member);
  // }
  AddTransactionPaymentOnline(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/AddTransactionPaymentOnline',member);
  }
  getOnlinePaymentMagPiePayNow(transaction:any) {
    return this.httpclient.post(environment.appUrl + '/api/PaymentGatewayMagPie/OnlinePaymentPayNowJoinOnline', transaction)
  }
  makePaymentAyden(model:any) {
    return this.httpclient.post(environment.appUrl + '/api/PaymentGatewayAdyen/MakePaymentAyden', model)
  }
  GetTerms(model:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/GetTerms', model)
  }



  getAllCityByGenderForJoinOnline(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/GetAllCityByGenderForJoinOnline',member);
  }
  getAllLocationByCityGenderForJoinOnline(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/GetAllLocationByCityGenderForJoinOnline',member);
  }
  ItemListWithoutCustomer(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/ItemListWithoutCustomer',member);
  }
  getAllCountryDialingCodes(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/Sentinel/GetAllCountryDialingCodes',member);
  }
  websiteInitialModel(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/WebsiteInitialModel',member);
  }
  AddTransactionItem(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/AddTransactionItem',member);
  }
  AddMemberFromJoinOnlineWebsite(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/AddMemberFromJoinOnlineWebsite',member);
  }
  PaymentOption(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/PaymentOption',member);
  }
  PaymentNow(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineBit/PaymentNow',member);
  }

  getTranslationFile(){
    return this.httpclient.post(environment.appUrl + '/api/Translation/GetTranslationFile',{})
  }
}
